module.exports = __webpack_public_path__ + "static/media/6-9.1d57eb2c.mp3";